import './LinkStyle.scss';

import PropTypes from 'prop-types';
import React from 'react';

const Link = ({ href, target, children, bold, ...props }) => (
  <a
    rel="noopener noreferrer"
    href={href || '#'}
    target={target || '_self'}
    className={bold ? 'link-bold' : ''}
    {...props}
  >
    {children}
  </a>
);

Link.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.node,
  bold: PropTypes.bool,
};

export default Link;
